import { Box, Flex, Heading } from "@chakra-ui/react"
import { useBlocksConfig } from "@pathwright/blocks-engine"
import { BlockText } from "@pathwright/blocks/src/shared"
import { Content } from "@pathwright/ui/src/components/content/Content"
import { useState } from "react"
import { TabItem } from "./TabsUI"

const TabsView = (props) => {
  const { data, id } = props

  const { templateVariables } = useBlocksConfig()

  const [selectedIndex, setSelectedIndex] = useState(0)

  const handleChangeSelectedIndex = (index) => () => {
    setSelectedIndex(index)
  }

  return (
    <Content.Container flexForPrint={true}>
      <Box
        border="1px solid rgba(0, 0, 0, 0.1)"
        boxShadow="0 0 20px 0 rgba(0, 0, 0, 0.1)"
      >
        <Box
          width="100%"
          overflowX="auto"
          overflowY="hidden"
          bgColor="#f5f5f5"
          className="swiper-no-swiping"
          style={{
            /* https://www.designernews.co/stories/91705-headsup-new-chrome-css-bug-makes-your-text-dissapear */
            /* Solves hidden tabs bug in Chrome */
            backfaceVisibility: "hidden"
          }}
        >
          <Flex direction="row" alignItems="center" role="tablist">
            {data.cards.map((slot, index) => (
              <TabItem
                key={`${id}-tab-${index}`}
                id={id}
                index={index}
                selected={selectedIndex === index}
                onClick={handleChangeSelectedIndex(index)}
                content={slot.html}
              >
                <Flex alignItems="center">
                  <Heading
                    as="h5"
                    m="0"
                    fontSize="1em"
                    fontWeight="700"
                    lineHeight="1.3em"
                    color="rgb(42, 46, 51)"
                  >
                    {slot.title}
                  </Heading>
                </Flex>
              </TabItem>
            ))}
          </Flex>
        </Box>
        {data.cards.map((slot, index) => (
          <Box
            key={`${id}-panel-${index}`}
            id={`${id}-panel-${index}`}
            padding="20px"
            /* Specify colors b/c of block styles*/
            backgroundColor="#fff"
            css={{
              "& .ql-editor p, & .ql-editor li": {
                // Ignore block styles colors
                color: "#000 !important"
              }
            }}
            role="tabpanel"
            aria-describedby={`${id}-tab-${index}`}
            aria-hidden={selectedIndex !== index}
            display={selectedIndex === index ? "block" : "none"}
          >
            <BlockText html={slot.html} templateContext={templateVariables} />
          </Box>
        ))}
      </Box>
    </Content.Container>
  )
}

export default TabsView
